import React, { Component } from 'react';
import { connect } from 'react-redux';

import { 
	ddnyFileTypeLabel,
	ddnyMediaSrc,
	ddnyTitle, 
} from '../../../../utils/ddny';

import Icon from '../../../common/icons/Icon';
import RhinoConfirm from '../../../common/confirm/RhinoConfirm';

import styles from './_styles/DirectoryMedia.module.scss';

import * as ddnyActionCreators from '../../../../actions/ddny';
const allActionCreators = Object.assign({}, ddnyActionCreators);

export class DirectoryMedia extends Component {

	constructor(props) {
	
		super(props);
	
		this.state = {
			deletePromptOpen: false,
		};
	}
	
	async handleDownload() {
		try {

			const response = await fetch(ddnyMediaSrc(this.props.media), { mode: 'cors' });
		
			if (!response.ok) throw new Error(`Failed to fetch file: ${response.statusText}`);
		
			const blob = await response.blob();
			const blobURL = window.URL.createObjectURL(blob);
		
			const link = document.createElement('a');
			link.href = blobURL;
			link.download = this.props.media.file_name;
			document.body.appendChild(link);
			link.click();
		
			// Cleanup
			document.body.removeChild(link);
			window.URL.revokeObjectURL(blobURL);

		} catch (error) {
			
			// Fallback if remote download fails, open in new tab
			console.error('Download error:', error);

			const link = document.createElement('a');
			const url = ddnyMediaSrc(this.props.media);

			link.href = url;
			link.download = this.props.media?.file_name || url.split('/').pop(); // Use provided filename or extract from URL
			link.target = '_blank'
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	}
	
	handleDownload() {
		
		const link = document.createElement('a');
		const url = ddnyMediaSrc(this.props.media);

		link.href = url;
		// link.download = this.props.media?.file_name || url.split('/').pop(); // Use provided filename or extract from URL
		link.target = '_blank'
		link.setAttribute('download', `catalog-${'this.state.downloadType'}-${'now'}.csv`);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);


		// const now = Date.now();
		// const template = Papa.unparse(csvLines);
		// const templateData = new Blob([ template ], { type: 'text/csv;charset=utf-8;' });
		// const templateURL = navigator.msSaveBlob ? navigator.msSaveBlob(templateData, `catalog-${this.state.downloadType}-${now}.csv`) : window.URL.createObjectURL(templateData);

		// let tempLink = document.createElement('a');
		// tempLink.href = templateURL;
		// tempLink.setAttribute('download', `catalog-${this.state.downloadType}-${now}.csv`);
		// tempLink.click();
	}

	async handleMoveUp() {
		try {

			this.props.setMediaLoading(true);

			await this.props.ddnyUpdateMedia(this.props.media.id, {
				product_id: this.props.product.id,
				sequence: this.props.last_sequence,
			});
			
			await this.props.refresh({ showLoading: false });

		} catch(err) {
			console.error(err);
		} finally {
			this.props.setMediaLoading(false);
		}
	}

	async handleDelete() {
	
		try {

			this.setState({ deletePromptOpen: false });
			this.props.setMediaLoading(true);

			await this.props.ddnyDeleteMedia(this.props.media.id)
			
			await this.props.refresh({ showLoading: false });

		} catch(err) {
			console.error(err);
		} finally {
			this.props.setMediaLoading(false);
		}
	}

	render() {

		if(!this.props.media) {
			return null;
		}

		return <div className={styles.DirectoryMedia}>
			<div className={styles.mediaWrapper}>
				<div className={styles.thumbSection}>
					{this.props.media.file_type === 'image'
						?	<div className={styles.imgWrapper}>
								<img alt={ddnyTitle(this.props.product)} src={ddnyMediaSrc(this.props.media)} />
							</div>
						:	<div className={styles.iconWrapper}>
								{this.props.media.file_type === 'video'
									?	<Icon value={'video'} />
									:	<Icon value={'file'} />
								}
							</div>
					}
				</div>
				<div className={styles.copySection}>
					<div className={`${styles.fileName} EllipsisElement`}>{this.props.media.file_name}</div>
					<div className={styles.fileType}>{ddnyFileTypeLabel(this.props.media.file_type, true)}</div>
				</div>
				<div className={styles.actionsSection}>
					{this.props.readOnly && (
						<div className={styles.iconButton} onClick={this.handleDownload.bind(this)}>
							<Icon value={'download'} />
						</div>
					)}
					{(!this.props.readOnly && this.props.last_sequence !== null) && (
						<div className={styles.iconButton} onClick={this.handleMoveUp.bind(this)}>
							<Icon value={'arrowUp'} />
						</div>
					)}
					{!this.props.readOnly && (
						<div className={styles.iconButton} onClick={() => this.setState({ deletePromptOpen: true })}>
							<Icon value={'close'} />
						</div>
					)}
				</div>
			</div>
			<RhinoConfirm
				confirmTitle='Delete?'
				confirmText='Are you sure you want to delete this media?'
				confirmButtonName={'Delete'}
				confirmClassName={'warning'}
				confirmMethod={this.handleDelete.bind(this)}
				cancelMethod={() => this.setState({ deletePromptOpen: false })}
				open={this.state.deletePromptOpen} />
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(DirectoryMedia);